import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, LogIn } from "lucide-react";
import { Input } from "../components/ui/input";
import { brand } from "../mock";

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("Invalid credentials");
      const data = await res.json();
      localStorage.setItem("rsp_token", data.access_token);
      nav("/admin");
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#faf9f9] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 justify-center mb-8">
          <div className="w-11 h-11 rounded-xl bg-white grid place-items-center border border-[#E5E5E5] shadow-sm overflow-hidden">
            <img src={brand.logo} alt="RSP" className="w-9 h-9 object-contain" />
          </div>
          <div className="leading-tight">
            <div className="text-lg font-semibold tracking-tight text-[#111]">
              RSP<span className="text-[#73100D]">Innov</span>
            </div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#666]">Admin Panel</div>
          </div>
        </div>

        <form onSubmit={onSubmit} className="bg-white rounded-2xl border border-[#E5E5E5] p-8 shadow-sm space-y-5">
          <h1 className="text-xl font-semibold text-[#111] mb-1">Sign in</h1>
          {error && (
            <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-4 py-2">{error}</div>
          )}
          <label className="block">
            <div className="text-xs uppercase tracking-[0.15em] text-[#666] mb-2 font-semibold">Email</div>
            <Input
              type="email" required value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="admin@rspinnovations.com"
              className="h-11 border-[#E5E5E5] focus-visible:ring-[#73100D]/30 focus-visible:border-[#73100D]"
            />
          </label>
          <label className="block">
            <div className="text-xs uppercase tracking-[0.15em] text-[#666] mb-2 font-semibold">Password</div>
            <Input
              type="password" required value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder="••••••••"
              className="h-11 border-[#E5E5E5] focus-visible:ring-[#73100D]/30 focus-visible:border-[#73100D]"
            />
          </label>
          <button
            type="submit" disabled={loading}
            className="w-full h-11 rounded-full bg-[#73100D] text-white font-semibold text-sm inline-flex items-center justify-center gap-2 hover:bg-[#5E0000] transition-colors disabled:opacity-70"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogIn className="w-4 h-4" />}
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="text-center text-xs text-[#999] mt-6">
          <a href="/" className="hover:text-[#73100D]">← Back to site</a>
        </p>
      </div>
    </div>
  );
}
